<template>
  <div>
    <el-row>
      <el-col :span="3">
        <el-select v-model="params.level" placeholder="请选择报警级别">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select v-model="params.status" placeholder="请选择处理状态">
          <el-option
            v-for="item in status"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-input v-model="params.code" placeholder="请输入报警编号"></el-input>
        
      </el-col>
      <el-col :span="3">
        <el-button type="primary" style="margin-left:10px;" @click="queryAlerm">检索</el-button>        
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24"><h1>最新事件监控TOP10</h1></el-col>
      <el-col :span="24">
        <el-table
          :data="tableData"
          style="width: 100%"
          :row-class-name="tableRowClassName"
        >
          <el-table-column type="expand" prop="content" label="">
            <template slot-scope="props">
              <h4>事件报警详细信息</h4>
              <span>{{ props.row.content }}</span>
              <h4>事件报警额外信息</h4>
              <span>{{ props.row.extra }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="发生时间">
          </el-table-column>
          <el-table-column prop="code" label="类型"> </el-table-column>
          <el-table-column prop="level" label="报警级别"> </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status==0">待处理</span>
              <span v-else-if="scope.row.status==1">已处理</span>
              <span v-else-if="scope.row.status==99">已忽略</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" v-if="scope.row.status==0" @click="ignore(scope.row)">忽略</el-button>
              <el-button type="text" size="small" v-if="scope.row.status==0" @click="sendAlerm(scope.row)"
                >发送报警</el-button
              >
              <el-button type="text" size="small" v-if="scope.row.status==0" @click="done(scope.row)">标记为已处理</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<style>
.el-table .warning-row {
  background: rgb(252, 229, 233) !important;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
<script>
import SysRobotApi from "@/api/SysRobotApi";
import MonitorLogApi from "@/api/MonitorLogApi";
export default {
  name: "Login",
  data() {
    return {
      tableData: [],
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "INFO",
          label: "INFO",
        },
        {
          value: "ERROR",
          label: "ERROR",
        },
      ],
      status: [
        {
          value: 0,
          label: "待处理",
        },
        {
          value:1,
          label: "已处理",
        },
        {
          value:99,
          label: "已忽略",
        },
      ],
      params:{
        level:"",
        status:0,
        code:"",
        pageNum:1,
        pageSize:20,
      }
      
    };
  },
  mounted() {
    this.queryAlerm();
  },
  methods: {
    ignore(item){
      this.$confirmDialog("确定要忽略此警报么？忽略之后将无法继续处理",()=>{
        let id = item.uuid;
        let params = {
          id:id
        }
        MonitorLogApi.ignore(params).then((resp) => {
          if (resp.state == "OK") {
            this.queryAlerm();
          }else{
            this.$errorMsg(resp.msg)
            }
        });
      })
    },
    done(item){
      this.$confirmDialog("确定要标记当前警报状态为已处理？",()=>{
        let id = item.uuid;
        MonitorLogApi.done({id}).then((resp) => {
          if (resp.state == "OK") {
            this.queryAlerm();
          }else{
            this.$errorMsg(resp.msg)
          }
        })
      })
    },
    tableRowClassName({ row, rowIndex }) {
      if ("INFO" === row.level || row.status!=0) {
        return "success-row";
      } else if ("ERROR" === row.level && row.status==0) {
        return "warning-row";
      }
      return "";
    },
    queryAlerm() {
      MonitorLogApi.alermList(this.params).then((resp) => {
        if (resp.state == "OK") {
          this.tableData = resp.data.records;
          this.$store.commit("refreshEventData", resp.data.records);
        }
      });
    },
    sendAlerm(item) {
      this.$confirmDialog("确定在报警群里发送报警信息么？",()=>{
        let content = `通知:\n警告出现，请及时处理！！！\n发生时间:${
        item.createTime
      }\n级别:${item.level}\n警报编号:${item.code}\n内容如下:\n${
        item.content
      }\n额外信息：${item.extra || "无"}`;
      let params = {
        atAll: false,
        content: content,
        mobiles: ["13641489216"],
        robotId: "service-monitor",
      };
      SysRobotApi.checkRobot(params).then((resp) => {
        if (resp.state == "OK") {
          this.$successMsg(resp.msg);
          this.robot = {};
          this.dialogVisible = false;
        } else {
          this.$errorMsg(resp.msg);
        }
      });
      })
      
    },
  },
};
</script>
